/**
 * Prepared drops section (campaign selector + creator)
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC, useLayoutEffect } from 'react';

import { LoadingSpinner } from '@/components/ui';
import { SmswiserCampaignPreparedDropsTab } from '@/features/smswiser-campaigns/components/SmswiserCampaignPreparedDropsTab';

import { getDefaultPreparedCampaignId } from '../constants';
import type { PreparedSectionProps } from '../types';

export const PreparedSection: FC<PreparedSectionProps> = ({
  countryKey,
  campaigns,
  selectedCampaignId,
  workDate,
  serverTitlePrefix,
  defaultSubTab,
  onSelectCampaign,
  isLoading,
  highlightPreparedDropId,
  onInvestigationFocusConsumed,
}) => {
  const effectiveCampaignId = selectedCampaignId ?? getDefaultPreparedCampaignId(campaigns) ?? null;
  const selectedCampaign = campaigns.find((c) => c.id === effectiveCampaignId);

  useLayoutEffect(() => {
    if (campaigns.length > 0 && selectedCampaignId == null && effectiveCampaignId != null) {
      onSelectCampaign(effectiveCampaignId);
    }
  }, [campaigns.length, selectedCampaignId, effectiveCampaignId, onSelectCampaign]);

  if (isLoading) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (campaigns.length === 0) {
    return (
      <div className="flex min-h-[320px] flex-1 flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-border bg-muted/10 p-8">
        <p className="text-sm text-muted-foreground">No campaigns found for this country</p>
      </div>
    );
  }

  if (!effectiveCampaignId || !selectedCampaign) {
    return null;
  }

  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col gap-4 overflow-hidden">
      <SmswiserCampaignPreparedDropsTab
        countryKey={countryKey}
        campaigns={campaigns}
        wiserId={effectiveCampaignId}
        workDate={workDate}
        campaignName={selectedCampaign.name}
        titlePrefix={serverTitlePrefix ?? ''}
        defaultSubTab={defaultSubTab}
        onSelectCampaign={onSelectCampaign}
        highlightPreparedDropId={highlightPreparedDropId}
        onInvestigationFocusConsumed={onInvestigationFocusConsumed}
      />
    </div>
  );
};
